import { S3_BASE_URI } from '@/constants/constants';

export const getElementFonts = (content: string) => {
  const fontNames = new Set<string>();

  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');
  const elementsWithStyle = doc.querySelectorAll('[style*="font-family"');
  elementsWithStyle.forEach(ele => {
    const style = ele.getAttribute('style');
    const fontMatch = style?.match(/font-family:\s*([^;]+)/);
    if (fontMatch) {
      const fontName = fontMatch[1].split(',')[0].trim().replace(/['"]/g, '');
      if (fontName && fontName.includes('font')) {
        fontNames.add(fontName);
      }
    }
  });
  return Array.from(fontNames);
};

export const loadFonts = async (fontNames: Array<string>) => {
  for (const fontName of fontNames) {
    const filename = fontName.replace('-ext-', '.');
    const uri = `${S3_BASE_URI}/fonts/${filename}`;
    const fontFace = new FontFace(fontName, `url(${uri})`);
    const font = await fontFace.load();
    document.fonts.add(font);
  }
};
